import {getViewAsToken} from './getViewAsToken'

export function isViewAsActive(): boolean {
  return Boolean(getViewAsToken())
}
